<template>
  <div style="max-width: 100vw!important;">
    <div class="bk-img"></div>
    <div class="w-header" v-if="isPc()">
      <div class="w-header-content-wrapper">
        <div data-animation="default" data-collapse="medium" data-duration="400" data-easing="ease" data-easing2="ease" role="banner" class="w-navbar w-nav">
          <Header activeMenuIndex="1"></Header>
        </div>
      </div>
    </div>
    <div class="header" v-if="!isPc()">
      <div class="w-header-content-wrapper">
        <div data-animation="default" data-collapse="medium" data-duration="400" data-easing="ease" data-easing2="ease" role="banner" class="w-navbar w-nav">
          <userHeader></userHeader>
        </div>
      </div>
    </div>
    <section>
      <div class="main-container">
        <div class="banner-container">
          <div class="banner-image">
            <h1 class="revo-heading">
              <span class="color-text">REVO</span>'s PARTNERS
            </h1>
          </div>
        </div>
        <div class="rankings">
          <Leaderboard id="leaderboard" :tokens="tokensSorted" :votes="user ? user.votes : []"/>
        </div>
        <rankingVotes style="margin-top: 15px"/>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
import { isPc } from "@/utils/common";
import Header from "@/components/header.vue";
import userHeader from "@/components/mobile/userHeader.vue";
import Banner from "@/components/banner-img.vue";
import request from "@/services/request";
import rankingVotes from "@/views/mobile/rankingVotes.vue";
import Leaderboard from "@/views/ranking/leaderboard.vue";
import Footer from "@/components/footer.vue";
export default {
  components: {
    Leaderboard,
    rankingVotes,
    Header,
    Banner,
    userHeader,
    Footer,
  },
  data() {
    return {
      tokens: [
        {
          "name": "GSC公链",
          "symbol": "GSC",
          "totalVotes": 0,
          "percent": 0,
        },
        {
          "name": "OORT公链",
          "symbol": "OORT",
          "totalVotes": 0,
          "percent": 0,
        },
        {
          "name": "CFX公链",
          "symbol": "CFX",
          "totalVotes": 0,
          "percent": 0,
        },
        {
          "name": "BTY公链",
          "symbol": "BTY",
          "totalVotes": 0,
          "percent": 0,
        }
      ],
      tokensSorted: [],
      user: null,
      lang: "",
      symbol: ""
    };
  },
  created() {
    this.lang = sessionStorage.getItem("Language");
    this.getUser();
    this.getTokens();
    this.calcVote();
  },
  methods: {
    calcVote() {
      let total = 0;
      this.tokens.forEach(token => {
        total += token.totalVotes;
      });
      if (total === 0) {
        total = 1;
      }
      this.tokens.forEach(token => {
        token.percent = token.totalVotes / total * 100;
      });
    },
    isPc,
    getUser() {
      request.getVotingUser().then((res) => {
        console.log(res)
        this.user = res;
      }).catch(error => {
        console.log(error);
        this.register();
      });
    },
    register() {
      request.register().then((res) => {
        this.user = res;
      }).catch(error => {
        console.log(error);
      });
    },
    getTokens() {
      request.rankingBoard().then((res) => {
        this.tokensSorted = res;
        res.forEach(token => {
          this.tokens.filter(_token => _token.symbol == token.symbol)[0].totalVotes = token.totalVotes;
        })
      });
    },
  },
};
</script>
<style lang='less' scoped>
.color-text{
  background: linear-gradient(90deg, rgba(242, 106, 255, 1), rgba(125, 111, 255, 1));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.bk-img {
  background-image: url("../../assets/img/home/bg-image-1_1bg-image-1.avif");
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 120px;
  padding-bottom: 350px;
  width: 100vw;
  height: 800px;
  position: absolute;
  top: -40px;
  left: 0;
  z-index: -100;
}
.bk-img::after {
  content: "";
  position: absolute;
  top: 400px;
  left: 0;
  width: 100%;
  height: 50%;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 100%);
}

.main-container {
  margin-top: 10px;
  display: flex;
  width: 90vw;
  justify-self: center;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .banner-container{
    display: flex;
    flex-direction: row;
    height: 400px;
    width: 100%;


    .banner-image{
      display: flex;
      object-fit: cover;
      width: 100%;
      height: 100%;
      background-color: rgba(157, 80, 187, 0.2);
      border-radius: 30px;
      justify-content: center;
      align-items: center;

      .revo-heading {

        font-size: 50px;
        text-align: center;
        position: relative;
        justify-self: center;
        align-self: center;
      }
    }
  }
  .rankings{
    padding-top: 20px;
    width: 100%;
    height: 100%;
    min-width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

</style>